module.exports = __webpack_public_path__ + "img/7.c7d8dd2e.jpg";